// Date du jour de l'entreprise : celle de Paris, jamais celle du serveur ni le temps universel.
// Entre minuit et 2 h (heure de Paris), le temps universel est encore la veille : une saisie datée en UTC
// et une autre datée par la base porteraient deux jours différents. Toute date « du jour » passe par ici.

export const FUSEAU_ENTREPRISE = 'Europe/Paris';
const FUSEAU = FUSEAU_ENTREPRISE;

/** Date du jour à Paris, au format AAAA-MM-JJ. */
export const dateDuJourParis = (maintenant: Date = new Date()): string =>
  new Intl.DateTimeFormat('fr-CA', { timeZone: FUSEAU, year: 'numeric', month: '2-digit', day: '2-digit' }).format(maintenant);

/** Date du jour à Paris, au format JJ/MM/AAAA (affichage, exports). */
export const dateDuJourParisFr = (maintenant: Date = new Date()): string =>
  new Intl.DateTimeFormat('fr-FR', { timeZone: FUSEAU, year: 'numeric', month: '2-digit', day: '2-digit' }).format(maintenant);
